module.exports = __webpack_public_path__ + "img/9788959761692.a49e8992.jpg";